// @flow

import reportInviteLand from 'app/packages/invite-utils/reportInviteLand';
import { parseQuery } from 'app/packages/url';

const logInviteAttribution = (): void => {
  if (__SERVER__) {
    return;
  }

  const query = parseQuery(window.location.search);
  const invite_code = query.invite_code;

  if (!invite_code) {
    return;
  }

  reportInviteLand(invite_code);
};

export default logInviteAttribution;
